export default __webpack_public_path__ + "static/media/IMG_1650.33609147.jpg";